<template>
  <div
    class="item-card"
    @click="dialog = true"
    @mouseover="isHovering = true"
    @mouseout="isHovering = false"
  >
    <div class="arrow" :class="isHovering ? 'arrow-show':''">
      <v-icon size="50px" color="#808F9C">keyboard_arrow_up</v-icon>
    </div>
    <div style="padding-top: 70px; text-align:center">
      <v-icon size="50px" color="#808F9C">add_circle_outline</v-icon>
    </div>

    <v-dialog max-width="500px" v-model="dialog" transition="dialog-bottom-transition">
      <v-card :loading="dialogLoading" ref="form">
        <v-card-title>
          <span class="headline">New Strategy</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  color="#4dbac0"
                  label="Name"
                  v-model="name"
                  ref="name"
                  :rules="[() => !!name || 'This field is required']"
                  :error-messages="errName"
                  counter
                  maxlength="20"
                  name="StrategyName"
                  required
                ></v-text-field>
                <div class="errors">
                  <li v-for="(error, index) in errors" :key="index">{{error}}</li>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="checkList"
                  :items="userTags"
                  itemText="name"
                  label="Checklist (optional)"
                  color="#4dbac0"
                  ref="checkList"
                  multiple
                  chips
                  return-object
                  autocomplete="off"
                  :menu-props="{ bottom: true, offsetY: true }"
                deletable-chips=""
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="description"
                  label="Ideal Trade Description (optional)"
                  counter
                  ref="description"
                  maxlength="1024"
                  color="#4dbac0"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="close" text>Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-slide-x-reverse-transition>
            <v-tooltip v-if="formHasErrors" left>
              <template v-slot:activator="{ on }">
                <v-btn icon class="my-0" @click="resetForm" v-on="on">
                  <v-icon color="primary">mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh form</span>
            </v-tooltip>
          </v-slide-x-reverse-transition>
          <v-btn color="primary" text @click="submit">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//color="#4dbac0"
import axios from "axios";
export default {
  name: "addStrategies",
  props: {addExternal: Number},
  data() {
    return {
      isHovering: false,
      dialog: false,
      name: null,
      description: null,
      checkList: [],
      dialogLoading: false,
      formHasErrors: false,
      errorMessages: "",
      errors: [],
      errName: [],
    };
  },

  computed: {
    form() {
      // extract only tag ids for save
      
      var checkListIds = [];
      if (this.checkList.length >0) {
        this.checkList.forEach(item => {
          checkListIds.push(item._id);
        });
      }

      return {
        name: this.name,
        description: this.description,
        //checkList: checkListIds,
        checkList: this.checkList
      };
    }
  },
  watch: {
    addExternal(){
      this.dialog = true
    },
    name() {
      this.errorMessages = "";
      this.errName = []
    },
    dialog() {
      this.dialogLoading = false;
      //this.resetForm();
    }
  },
  asyncComputed: {

    userTags: {
      get() {
        return new Promise(resolve => {
          axios
            .post("https://tradeinpool.com:3001/api/request/tags/", {
              method: "basic",
            })
            .then(response => {
              resolve(response.data);
              this.loaded = true;
            })
        });
      },
      default: []
    }
  },
  methods: {
    addStrategy(){

    },
    /*
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset();
      });
    },
    */
    close() {
      this.dialog = false;
      this.formHasErrors = false;
      this.checkList = [];
      this.errName = [];
      this.description = null;
      this.name = null;
    },
    submit() {
      this.formHasErrors = false;

      if (!this.form["name"]) this.formHasErrors = true;
      this.$refs["name"].validate(true);

      if (this.formHasErrors == false) {
        this.dialogLoading = true;
        axios
            .post("https://tradeinpool.com:3001/api/add/strategies/",{
              data: this.form
              })
            .then(response => {
              this.close();
              this.$emit("newStrategy",response.data)
              this.dialogLoading = false;
            })
            .catch(err => {
              this.errName = err.response.data.message
              this.dialogLoading = false;
            })
      }
    }
  }
};
</script>

<style scoped>
.item-card {
  border-radius: 3px;
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  cursor: pointer;
  height: 100%;
  min-height: 180px;
  transition: 0.5s;
}
.item-card:hover {
  background: #232a35;
}
.item-title {
  color: #4dbac0;
  font-family: "Roboto", "Roboto Condensed", sans-serif;
  font-weight: bold;
  font-size: 16px;
}
.arrow {
  position: absolute;
  bottom: -100%;
  padding-top: 0px;
  text-align: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  transition: 0.5s;
}
.arrow-show {
  bottom: 0%;
}

.headline {
  color: #4dbac0;
}
</style>